import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  background?: 'primary' | 'secondary' | 'card';
  id?: string;
}
export function Section({
  children,
  className = '',
  background = 'primary',
  id
}: SectionProps) {
  const backgrounds = {
    primary: 'bg-navy-900',
    secondary: 'bg-navy-800',
    card: 'bg-navy-700'
  };
  return <section id={id} className={`py-16 md:py-24 ${backgrounds[background]} ${className}`} data-id="element-203">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-204">{children}</div>
    </section>;
}